export function collectionDeadline(now: Date): Date {
  return new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999)
}

export function daysUntilCollectionDeadline(now: Date): number {
  const deadline = collectionDeadline(now)
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const startOfDeadlineDay = new Date(deadline.getFullYear(), deadline.getMonth(), deadline.getDate())
  const msPerDay = 24 * 60 * 60 * 1000

  return Math.max(0, Math.round((startOfDeadlineDay.getTime() - startOfToday.getTime()) / msPerDay))
}

export function guideYear(now: Date): number {
  return now.getFullYear() + 1
}
